
export default {
  props: {
    location: {
      type: Object,
      required: true,
    },
  },

  computed: {
    count() {
      return Math.floor(this.location.count / 10) * 10;
    },

    webpPhoto() {
      const photo = this.location?.photo;
      if (!photo) return "";
      if (photo.endsWith(".webp")) return photo;

      return `${photo}.webp`;
    },
  },
};
